// extracted by mini-css-extract-plugin
module.exports = {"createButton":"CreateOrderNote_createButton__3x4-g","buttonsContainer":"CreateOrderNote_buttonsContainer__2PsEN"};